/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Src_EbranaInputs */

const cs_jobs_src_ebrana = /** @type {(inputs: Jobs_Src_EbranaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána`)
};

const en_jobs_src_ebrana = /** @type {(inputs: Jobs_Src_EbranaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána`)
};

/**
* | output |
* | --- |
* | "eBrána" |
*
* @param {Jobs_Src_EbranaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_src_ebrana = /** @type {((inputs?: Jobs_Src_EbranaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Src_EbranaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_src_ebrana(inputs)
	return cs_jobs_src_ebrana(inputs)
});